export default __webpack_public_path__ + "static/Header-72f1c90162c438c7e7c04719b2e52406.png";